import React from "react";
import { History } from "history";
import {
  PlanoVinculadoEntidade,
  ContratoEntidade,
  ParametrosSimulacao,
  ContratoDisponivel,
} from "../../../../entidades";
import { Page } from "../../..";
import { NumFuncionalidade } from "../../../Page";
import { Box, CampoEstatico, TipoCampoEstatico, Alerta, TipoAlerta, Botao, TipoBotao, Col, Row, } from "@intechprev/componentes-web";
// import { IParametrosSimulacao } from "./../Inicio";
import { EmprestimoService } from "../../../../services";

interface IProps {
  history?: History;
}

interface IState {
  plano: string;
  Carencia: number;
  CdNatur: number;
  CdModal: number;
  emprestimos: Array<ContratoEntidade>;
  valorSolicitado: number;
  valorMargemConsignavel: number;
  saldoContratosAtivos: number;
  valorFinanciado: number;
  listaContratos: Array<ContratoDisponivel>;
  contratoSelecionado: ContratoDisponivel;

  erro: string;
}

export class EmprestimoSimuladorPrestacoes extends React.Component<IProps, IState> {

  private page = React.createRef<Page>();

  constructor(props: IProps) {
    super(props);

    const dados: ParametrosSimulacao = JSON.parse(
      localStorage.getItem("emprestimo-parametros")
    );

    var recursoUtilizado = 0;

    if (dados.emprestimos.length > 0) {
      recursoUtilizado = dados.emprestimos.map(x => x.SaldoDevedor.ValorReformado).reduce((x, y) => x + y);
    }

    this.state = {
      plano: dados.CdPlano,
      Carencia: dados.Carencia,
      emprestimos: dados.emprestimos,
      valorSolicitado: dados.valorSolicitado,
      valorMargemConsignavel: dados.ValorMargem,
      saldoContratosAtivos: recursoUtilizado,
      valorFinanciado: dados.valorSolicitado + recursoUtilizado,
      CdNatur: dados.CdNatur,
      CdModal: dados.CdModal,
      listaContratos: [],
      contratoSelecionado: null,

      erro: null,
    };
  }

  componentDidMount = async () => {
    await this.page.current.loading(true);
    try {

      var parametros: ParametrosSimulacao = {
        CdPlano: this.state.plano,
        ValorMargem: this.state.valorMargemConsignavel,
        valorSolicitado: this.state.valorSolicitado,
        Carencia: this.state.Carencia,
        CdNatur: this.state.CdNatur,
        CdModal: this.state.CdModal
      };

      var listaContratos = await EmprestimoService.BuscarParcelas(parametros);
      this.setState({
        listaContratos,
      });

    } catch (err) {
      const error: any = err;
      this.setState({
        erro: error.response ? error.response.data : error,
      });
    }
    finally {
      await this.page.current.loading(false);
    }
  };

  selecionarContrato = async (contrato: ContratoDisponivel) => {
    if (contrato.Disponivel) {
      const listaContratos = this.state.listaContratos.map((item) => {
        return {
          ...item,
          Selecionado: item.Prazo === contrato.Prazo,
        };
      });

      contrato.Selecionado = true;

      this.setState({
        listaContratos,
        contratoSelecionado: contrato,
      });
    }
  };

  continuar = async () => {
    if (this.state.contratoSelecionado) {
      localStorage.setItem(
        "emprestimo-contrato-selecionado",
        JSON.stringify(this.state.contratoSelecionado)
      );
      this.props.history.push("/emprestimo/simuladorresumo");
    }
  };

  render() {
    return (
      <Page Funcionalidade={NumFuncionalidade.EMPRESTIMOS_SIMULAÇÃO} {...this.props} ref={this.page}      >
        <h3>Bem-Vindo ao Simulador de Empréstimos da São Francisco!</h3>
        {/* <h5>
          Ao final da sua simulação você poderá realizar o
          requerimento do seu empréstimo diretamente por aqui, de
          forma on-line e segura!
        </h5> */}

        <Box titulo={"Prazos e Prestações"}>
          <p>Selecione o melhor prazo/taxa disponível para você!</p>

          <Row>
            <Col tamanho={"12"} className={"col-lg-6"}>
              <CampoEstatico
                titulo={"Líquido a Receber"}
                valor={this.state.valorSolicitado}
                tipo={TipoCampoEstatico.dinheiro}
                tamanhoTitulo={"6"}
              />
            </Col>

            <Col tamanho={"12"} className={"col-lg-6"}>
              <CampoEstatico
                titulo={"Margem Consignável"}
                valor={this.state.valorMargemConsignavel}
                tipo={TipoCampoEstatico.dinheiro}
                tamanhoTitulo={"6"}
              />
            </Col>
          </Row>

          <Row>
            <Col tamanho={"12"} className={"col-lg-6"}>
              <CampoEstatico
                titulo={"Saldo Contratos Ativos"}
                valor={this.state.saldoContratosAtivos}
                tipo={TipoCampoEstatico.dinheiro}
                tamanhoTitulo={"6"}
              />
            </Col>

            <Col tamanho={"12"} className={"col-lg-6"}>
              <CampoEstatico
                titulo={"Juros Aplicado"}
                valor={this.state.listaContratos.length > 0 && this.state.listaContratos[0].TaxaJuros}
                tipo={TipoCampoEstatico.percentual}
                tamanhoTitulo={"6"}
              />
            </Col>
          </Row>

          {this.state.erro && (
            <Alerta
              tipo={TipoAlerta.danger}
              mensagem={this.state.erro}
            />
          )}
          {this.state.listaContratos.length > 0 && (
            <table
              className={"table table-hover mt-5"}
              style={{ cursor: "pointer" }}
            >
              <thead>
                <tr>
                  <th style={{ width: "1px" }}></th>
                  <th style={{ width: "70px" }}>{"Prazo"}</th>
                  {/* <th style={{ width: "70px" }}>{"Taxa"}</th> */}
                  <th style={{ width: "120px" }}>{"Prestação"}</th>
                  <th style={{ width: "120px" }}>{"Taxa Administração"}</th>
                  <th style={{ width: "120px" }}>{"Taxa Seguro Empréstimo"}</th>
                  <th style={{ width: "120px" }}>{"Valor do IOF"}</th>
                  <th style={{ width: "120px" }}>{"Valor Bruto a Solicitar"}</th>
                  <th>{"Disponibilidade"}</th>
                </tr>
              </thead>
              <tbody>
                {this.state.listaContratos.map(
                  (contrato: ContratoDisponivel, index: number) => {
                    return (
                      <tr key={index} onClick={() => this.selecionarContrato(contrato)}>
                        <td>
                          {contrato.Disponivel &&
                            contrato.Selecionado && (
                              <i
                                className={
                                  "fas fa-circle text-success"
                                }
                              ></i>
                            )}

                          {contrato.Disponivel &&
                            !contrato.Selecionado && (
                              <i
                                className={
                                  "far fa-circle"
                                }
                              ></i>
                            )}

                          {!contrato.Disponivel && (
                            <i
                              className={
                                "far fa-times-circle text-danger"
                              }
                            ></i>
                          )}
                        </td>
                        <td>{contrato.Prazo}</td>
                        {/* <td>
                          <CampoEstatico
                            valor={contrato.TaxaJuros}
                            tipo={TipoCampoEstatico.percentual}
                          />
                        </td> */}
                        <td>
                          <CampoEstatico
                            valor={contrato.ValorPrestacao}
                            tipo={TipoCampoEstatico.dinheiro}
                          />
                        </td>
                        <td>
                          <CampoEstatico
                            valor={contrato.ValorTaxaAdministracao}
                            tipo={TipoCampoEstatico.dinheiro}
                          />
                        </td>
                        <td>
                          <CampoEstatico
                            valor={contrato.ValorTaxaSeguro}
                            tipo={TipoCampoEstatico.dinheiro}
                          />
                        </td>
                        <td>
                          <CampoEstatico
                            valor={contrato.ValorIOF}
                            tipo={TipoCampoEstatico.dinheiro}
                          />
                        </td>
                        <td>
                          <CampoEstatico
                            valor={contrato.ValorSolicitado}
                            tipo={TipoCampoEstatico.dinheiro}
                          />
                        </td>
                        <td>
                          <span className={`text-${contrato.Disponivel ? "success" : "danger"}`}>
                            {contrato.Disponivel ? "Disponível" : contrato.Motivo}
                          </span>
                        </td>
                      </tr>
                    );
                  }
                )}
              </tbody>
            </table>
          )}

          <Botao
            titulo={"Voltar"}
            tipo={TipoBotao.light}
            onClick={() => this.props.history.goBack()}
            icone={"fas fa-chevron-left"}
          />

          <Botao
            titulo={"Resumo"}
            className={"ml-2"}
            onClick={this.continuar}
            icone={"fas fa-chevron-right"}
            desativado={!this.state.contratoSelecionado}
            iconeDireita
            submit
          />
        </Box>
      </Page>
    );
  }
}
